import gql from 'graphql-tag';
import { PRODUCT_FIELDS, PLAN_FIELDS, CUSTOMER_FIELDS, USER_FIELDS, SUBSCRIPTION_FIELDS } from './fragments';

export const PRODUCTS_QUERY = gql`
  {
    products {
      ...ProductFields
      plans {
        ...PlanFields
      }
    }
  }
  ${PRODUCT_FIELDS}
  ${PLAN_FIELDS}
`;

export const CURRENT_CONTEXT_QUERY = gql`
  {
    customer {
      ...CustomerFields
    }
    subscription {
      ...SubscriptionFields
      plan {
        ...PlanFields
      }
    }
    user {
      ...UserFields
    }
    organisation {
      id
      trialEndsAt
      product {
        ...ProductFields
      }
    }
  }
  ${CUSTOMER_FIELDS}
  ${SUBSCRIPTION_FIELDS}
  ${PRODUCT_FIELDS}
  ${PLAN_FIELDS}
  ${USER_FIELDS}
`;

export const PLAN_CALCULATE_PRICE_QUERY = gql`
  query PlanCalculatePrice(
    $id: String!
    $countryCode: String!
    $couponCode: String
    $includeTax: Boolean
    $stateCode: String
    $taxNumber: String
  ) {
    plan(id: $id) {
      ...PlanFields
      calculatePrice(
        countryCode: $countryCode
        couponCode: $couponCode
        includeTax: $includeTax
        stateCode: $stateCode
        taxNumber: $taxNumber
      ) {
        taxRate
        gross
        taxes
        discount
        net
        taxIncluded
      }
    }
  }
  ${PLAN_FIELDS}
`;

export const BILLING_INFO = gql`
  {
    customer {
      ...CustomerFields
    }
    subscription {
      ...SubscriptionFields
    }
  }
  ${CUSTOMER_FIELDS}
  ${SUBSCRIPTION_FIELDS}
`;
